import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'

import ProgressButton from '../../../../components/Form/ProgressButton'

function StepFormSubmit({
  errorSelector,
  isLoadingSelector,
  clearHandler,
  submitText = 'Save',
  isSubmitDataLoading,
  ...props
}) {
  const { t } = useTranslation()

  const formError = useSelector(errorSelector)
  const isFormLoading = useSelector(isLoadingSelector)

  return isSubmitDataLoading ? (
    <Skeleton height={37} width={65} />
  ) : (
    <ProgressButton formError={formError} isFormLoading={isFormLoading} clearHandler={clearHandler} {...props}>
      {t(submitText)}
    </ProgressButton>
  )
}

export default StepFormSubmit

StepFormSubmit.propTypes = {
  submitText: PropTypes.string,
  errorSelector: PropTypes.func.isRequired,
  isLoadingSelector: PropTypes.func.isRequired,
  isSubmitDataLoading: PropTypes.bool,
  clearHandler: PropTypes.func
}
